import Box from '@zenbusiness/zui/Box';
import Paper from '@zenbusiness/zui/Paper';
import { styled } from '@zenbusiness/zui/styles';

const PaperStyle = () => ({
  padding: '24px',
  margin: '24px auto',
  '&.MuiPaper-rounded': {
    borderRadius: '18px'
  }
});

export const WrapperStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
});

const BannerWrapperStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '1 / 13',
    width: 'auto'
  }
});

export const PaperStyled = styled(Paper)(PaperStyle);
export const Wrapper = styled(Box)(WrapperStyle);
export const BannerWrapper = styled(Box)(BannerWrapperStyle);
